import { useMemo } from 'react';
import { apiClient } from '../../../api/client';
import { url as apiUrl } from '../../../api';
import { getAuthToken } from '../../../utils/authTokens';
import { COFFEE_API_BASE } from '../../coffee_card_web/api/paths';
import { useLocalCache, UseLocalCacheResult } from '../utils/swrCache';

const url = apiUrl || process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001';

export interface YourHistoryItem {
    ratingId: string;
    coffeeType: string;
    overallRating: number;
    quickRate: number | null;
    takenAt: string;
    imageUrl: string | null;
}

export interface YourHistoryResponse {
    count: number;
    avgRating: number;
    firstRatedAt: string | null;
    lastRatedAt: string | null;
    items: YourHistoryItem[];
}

export function useShopYourHistory(shopId: string | undefined): UseLocalCacheResult<YourHistoryResponse> {
    const key = shopId ? `coffee_shop_history_${shopId}` : null;

    const fetcher = useMemo(
        () => async () => {
            const token = getAuthToken();
            const response = await apiClient.get<YourHistoryResponse>(
                `${url}${COFFEE_API_BASE}/shops/${shopId}/your-history`,
                { headers: token ? { Authorization: `Bearer ${token}` } : {} }
            );
            return response.data;
        },
        [shopId]
    );

    return useLocalCache<YourHistoryResponse>(key, 5 * 60 * 1000, fetcher);
}
